import React, { useState, useEffect } from "react";

//custom
import { Routes, Route } from "react-router-dom";
import { Link } from "react-router-dom";

//component
import ProgressLoader from "./components/ProgressLoader/ProgressLoader";

//views
import Home from "./views/Home/Home";
import Login from "./views/Login/Login";
import EditProfile from "./views/EditProfile/EditProfile";
import MyProfile from "./views/MyProfile/MyProfile";
import TopicList from "./views/TopicList/TopicList";
import ContentList from "./views/ContentList/ContentList";

//viewsAdmin
import ManageUser from "./viewsAdmin/ManageUser/ManageUser";

function App() {
  return (
    <div className="App">
      <Link to={"/login"} id="app_login_link" className="hide">
        login
      </Link>
      <Link to={"/home"} id="app_home_link" className="hide">
        home
      </Link>
      <Link to={"/editprofile"} id="app_edit_profile_link" className="hide">
        editprofile
      </Link>
      <Link to={"/myprofile"} id="app_my_profile_link" className="hide">
        myprofile
      </Link>
      <br />
      <br />
      <br />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/login" element={<Login />} />
        {/*<Route path="/editprofile" element={<EditProfile />} />*/}
        <Route path="/myprofile" element={<MyProfile />} />
        <Route path="/course/:courseid" element={<TopicList />} />
        <Route path="/topic/:topicid" element={<ContentList />} />

        <Route path="/admin/manageuser" element={<ManageUser />} />

        <Route path="/*" element={<Home />} />
      </Routes>
      <ProgressLoader />
      <br />
      <br />
      <br />
    </div>
  );
}

export default App;
